module.exports = __webpack_public_path__ + "static/media/hero-img.a34169ac.png";